// extracted by mini-css-extract-plugin
export default {"container":"PageHeading_container__DgWvK"};